import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

const Banner = ({ className, text }) => {
  const containerClasses = cx(
    {
      [styles.container]: true,
    },
    className
  );

  return (
    <div className={containerClasses}>
      <h4 className={styles.text}>{text}</h4>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js